import * as React from 'react';
import classNames from 'classnames';

import { SearchButtonContainer } from '../../search_button/container';
import { NewbuildingConsultantInFilter } from '../../../../common/components/NewbuildingConsultantPopup/NewbuildingConsultantInFilter';
import { trackAdvancedFiltersApplied } from './tracking';

const style = require('./index.css');

export interface IAdvancedModalFooterProps {
  jsonQueryUrl: string | undefined;
  newbuildingConsultantPopup: boolean;
  onClick(): void;
  openChat(): void;
}

export class AdvancedModalFooter extends React.Component<IAdvancedModalFooterProps> {
  public render() {
    const { newbuildingConsultantPopup, openChat } = this.props;

    return (
      <div className={classNames(style['footer'], newbuildingConsultantPopup && style['footer-withNbConsultant'])}>
        <SearchButtonContainer onClick={this.handleSearchButtonClick} />
        {newbuildingConsultantPopup && <NewbuildingConsultantInFilter onClick={openChat} />}
      </div>
    );
  }

  private handleSearchButtonClick = () => {
    trackAdvancedFiltersApplied(this.props.jsonQueryUrl);
    this.props.onClick();
  };
}
